const XLSX_FILE_SCHEMA = {
  STUDENT: {
    'Tên học sinh': {
      prop: 'name',
      type: String
    },
    'Mã số': {
      prop: 'code',
      type: String
    }
  },
  TEACHER: {
    'Tên giáo viên': {
      prop: 'name',
      type: String
    },
    'Mã số': {
      prop: 'code',
      type: String
    }
  }
}

const XLSX_FILE_TEMPLATE = {
  STUDENT: {
    example: [{ name: 'Nguyễn Khánh Huyền', code: '06603' }],
    header: [
      { text: 'Tên học sinh', value: 'name' },
      { text: 'Mã số', value: 'code' }
    ],
    title: 'Mẫu nhập danh sách học sinh kèm mã số'
  },
  TEACHER: {
    example: [{ name: 'GV-TEST', code: 'LTV0123' }],
    header: [
      { text: 'Tên giáo viên', value: 'name' },
      { text: 'Mã số', value: 'code' }
    ],
    title: 'Mẫu nhập danh sách giáo viên kèm mã số'
  }
}

const getTemplate = (type = 'student') => {
  if (type === 'student') return XLSX_FILE_TEMPLATE.STUDENT
  return XLSX_FILE_TEMPLATE.TEACHER
}
const getSchema = (type = 'student') => {
  if (type === 'student') return XLSX_FILE_SCHEMA.STUDENT
  return XLSX_FILE_SCHEMA.TEACHER
}

export { getTemplate, getSchema }
